import { View3dConfigurationDto } from '@canvas-logic/clp-viewer3d';
import { IConfiguratorUIDto } from '@canvas-logic/clp-api-types';

// Minimal stand-in used when the UI spec cannot be fetched. Consumers require the full
// DTO, so it is typed as such — the cast below is what lets the partial literal stand in.
export const uiFallBack: IConfiguratorUIDto = {
  localization: 'en',
  layout: {
    controlsHidden: false,
  },
} as unknown as IConfiguratorUIDto;
export const view3dFallBack: View3dConfigurationDto = {
  views: [],
  hierarchy: {
    root: {
      partId: 'empty',
      children: [],
    },
  },
  camera: {},
  parts: [
    {
      id: 'empty',
      view: {
        selector: 'view',
        match: {
          '*': '*',
        },
      },
      materials: [],
    },
  ],
  materials: [],
} as any;

export const ConfiguratorParams = {
  link: 'link',
  draft: 'draft',
  catalogId: 'catalogId',
  configurationId: 'configurationId',
  hideConfigurationControls: 'hideConfigurationControls',
  background: 'background',
  mode: 'mode',
};
